import { Head, Link } from '@inertiajs/react'
import { useCallback } from 'react'

import ComponentLibraryPanel from '../../components/sandbox/ComponentLibraryPanel'
import { SANDBOX_COMPONENT_PRESETS } from '../../lib/sandboxComponentPresets'

export default function SandboxLibrary() {
  const noopLoad = useCallback(() => {}, [])

  return (
    <>
      <Head title="Component library" />
      <div className="flex w-full min-w-0 flex-1 flex-col gap-4">
        <header className="shrink-0 border-b border-outline-variant/20 pb-4">
          <p className="mb-1 font-mono text-[10px] font-bold tracking-widest text-on-surface-variant uppercase">
            <Link
              href="/tools/sandbox"
              className="text-primary-container underline decoration-primary-container/35 underline-offset-2 hover:decoration-primary-container"
            >
              Sandbox
            </Link>
            <span aria-hidden className="text-on-surface-variant/50">
              {' '}
              /{' '}
            </span>
            <span>Library</span>
          </p>
          <h1 className="font-headline text-2xl font-bold tracking-tighter text-on-surface uppercase md:text-3xl">
            Component library
          </h1>
          <p className="mt-1 max-w-4xl font-mono text-[11px] leading-relaxed tracking-wide text-on-surface-variant md:text-xs">
            Browse vanilla HTML, CSS, and JavaScript examples. Open any in the{' '}
            <Link href="/tools/sandbox" className="text-primary-container underline underline-offset-2">
              sandbox
            </Link>{' '}
            in a new tab.
          </p>
        </header>

        <ComponentLibraryPanel
          presets={SANDBOX_COMPONENT_PRESETS}
          strictMode={false}
          onLoad={noopLoad}
          variant="page"
        />
      </div>
    </>
  )
}
